import type { RootState } from "@/store"

const selectTgInsets = () => (state: RootState) => state.devTools.tgInsets
const selectTgInsetsPresetId = () => (state: RootState) =>
  state.devTools.tgInsetsPresetId
const selectEmulatePhoneDevice = () => (state: RootState) =>
  state.devTools.emulatePhoneDevice
const selectTmaOverride = () => (state: RootState) => state.devTools.tmaOverride

export const DevToolsSelectors = {
  selectTgInsets,
  selectTgInsetsPresetId,
  selectEmulatePhoneDevice,
  selectTmaOverride
}
